import { useLingui } from "@lingui/react";
import { IApiSmpAgTranslation } from "@smp/api";

export const useSmpAgTranslation = (): ((
  source: IApiSmpAgTranslation | null,
) => string) => {
  const {
    i18n: { locale },
  } = useLingui();

  return (source) =>
    source ? source[locale] || source["en"] || source["ru"] || "" : "";
};
